import { render, staticRenderFns } from "./DynamicContent.vue?vue&type=template&id=02dea7a2&"
import script from "./DynamicContent.vue?vue&type=script&lang=js&"
export * from "./DynamicContent.vue?vue&type=script&lang=js&"
import style0 from "./DynamicContent.vue?vue&type=style&index=0&id=02dea7a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports